"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const icons_1 = require("./icons");
const CssTextField = styles_1.styled(core_1.TextField)({
    "& label.Mui-focused": {
        color: "#CECACA",
        background: "#fff",
    },
    "& .MuiInput-underline:after": {
        borderBottomColor: "#CECACA",
    },
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "#CECACA",
        },
        "&:hover fieldset": {
            borderColor: "#CECACA",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#CECACA",
        },
    },
});
function SearchBar(props) {
    return (react_1.default.createElement(CssTextField, { InputLabelProps: { shrink: false }, placeholder: props.placeholder || "search", InputProps: {
            style: { width: "100%", height: "30px", paddingRight: "8px", fontSize: "14px", marginBottom: "30px" },
            endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                react_1.default.createElement(icons_1.SearchIconLarge, null))),
        }, style: { width: "100%" }, onChange: props.onChange, variant: "outlined" }));
}
exports.SearchBar = SearchBar;
//# sourceMappingURL=SearchBar.js.map